import { useHttp } from "../http/useHttp";
import { useAxiosQuery, UseAxiosQueryOptions } from "../http/useAxiosQuery";
import { useMemo } from "react";
import { useAuth } from "../auth/useAuth";
import { paths } from "../generated-types";

type NodeUsersOperation = paths["/dashboard/synota/list-users"]["post"];
export type UseNodeUsersInput = NodeUsersOperation["requestBody"]["content"]["application/json"];
export type UseNodeUsersResponse =
  NodeUsersOperation["responses"][200]["content"]["application/json"];
export type INodeUser = UseNodeUsersResponse["users"][number];

export const useNodeUsers = (
  input: UseNodeUsersInput,
  options: Omit<UseAxiosQueryOptions<UseNodeUsersResponse>, "queryKey" | "queryFn"> = {},
) => {
  const { client } = useHttp();
  const { isAdmin } = useAuth();

  const { status, isPending, isFetching, isLoading, data, error, refetch } =
    useAxiosQuery<UseNodeUsersResponse>({
      queryKey: ["node-list-users", input],
      queryFn: ({ signal }) => client.post("/synota/list-users", input, { signal }),
      ...options,
      enabled: Boolean(
        isAdmin && (input.api_url || input.server_uuid) && options.enabled !== false,
      ),
    });

  const nodeUsers = useMemo(() => {
    if (!data) {
      return [];
    }
    return data.data.users.sort((a, b) => a.role.localeCompare(b.role));
  }, [data]);

  return {
    nodeUsers,
    error,
    isLoading,
    isFetching,
    isPending,
    status,
    refetch,
  };
};

export type UseNodeUsersReturn = ReturnType<typeof useNodeUsers>;
